import { sortingMethods } from '../../../../constants/table';
import CustomCell from '../../../../components/Table/CustomCell';
import { PORTAL_ROUTE } from '../../../../constants/routes';

export const catalogInventoryTableColumnsOrder = [
  { name: 'application', styles: { wordBreak: 'break-word' } },
  { name: 'catalogName', styles: { wordBreak: 'break-word' } },
  { name: 'deviceCount' },
  { name: 'origin' },
  { name: 'lastSeen' },
];

export const catalogInventoryTableHeadings = [
  {
    title: 'Application',
    name: 'application',
    hasSorting: true,
    width: '20%',
    sortMethod: sortingMethods.initial,
    field: 'FilterCatalogInventoryResult',
    sortingCellField: 'ApplicationName',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Catalog Name',
    name: 'catalogName',
    hasSorting: true,
    width: '28%',
    sortMethod: sortingMethods.initial,
    field: 'FilterCatalogInventoryResult',
    sortingCellField: 'CatalogName',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Device Count',
    name: 'DeviceCount',
    hasSorting: true,
    width: '14%',
    sortMethod: sortingMethods.initial,
    field: 'FilterCatalogInventoryResult',
    sortingCellField: 'DeviceCount',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Origin',
    name: 'origin',
    hasSorting: false,
    width: '18%',
  },
  {
    title: 'Last seen',
    name: 'lastSeen',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterCatalogInventoryResult',
    sortingCellField: 'LastSeen',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
];
export const catalogInventoryIsSignedParamList = [
  {
    label: 'Signed',
    value: true,
  },
  {
    label: 'Unsigned',
    value: false,
  },
];

export const catalogInventorySidebarList = [
  {
    title: 'Device tags',
    name: 'Tags',
  },
  {
    title: 'Origins',
    name: 'Filter',
  },
  {
    title: 'Is Signed',
    name: 'IsSigned',
    options: catalogInventoryIsSignedParamList,
    useCheckbox: true,
  },
];

const fmt = (value, loading) => (loading ? '...' : value ?? 0);

export const wdacCatalogInventoryTabs = (catalogInventoryId, affectedCount, notConnectedCount, loading = false) => [
  {
    label: `Details`,
    value: `${PORTAL_ROUTE}/catalog-inventory-details/${catalogInventoryId}/details`,
  },
  {
    label: `Devices With Catalog Inventory (${fmt(affectedCount, loading)})`,
    value: `${PORTAL_ROUTE}/catalog-inventory-details/${catalogInventoryId}/devices`,
  },
  {
    label: `Devices Without Catalog Inventory (${fmt(notConnectedCount, loading)})`,
    value: `${PORTAL_ROUTE}/catalog-inventory-details/${catalogInventoryId}/not-connected-devices`,
  },
];

export const WDAC_CATALOG_INVENTORY_PREVIOUS_PATH = 'wdacCatalogInventory';
